import useConfig from 'UI/customHooks/useConfig';
import { useT } from 'UI/lib';
import React from 'react';
import ExplainFeatureButton from '../../components/ExplainFeatureButton';
import useExplainVideoURL from 'UI/customHooks/useExplainVideoURL';

const ReportsDownloadTitle = ({ title }) => {
  const t = useT();
  const config = useConfig();
  const videoUrlAlt = useExplainVideoURL('reports');

  const videoUrl = config?.cms?.features?.modal?.reports?.videoUrl;

  return (
    <div data-test="report-modal-title">
      {title || t('restrict:company_view.report.download_report')}
      {(videoUrl || videoUrlAlt) && (
        <ExplainFeatureButton deprecatedVideoUrl={videoUrlAlt || videoUrl} data-test="info-video" />
      )}
    </div>
  );
};

export default ReportsDownloadTitle;
